import React from 'react';

const DoneIcon = (props: React.SVGProps<SVGPathElement>) => {
  return (
    <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4572 1.66113L4.77961 8.33847L1.4408 4.99995"
        stroke="white"
        strokeWidth="1.52632"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      />
    </svg>
  );
};

export default DoneIcon;
